function NotFound() {
  return (
    <div>
      <h2>404</h2>
      <p>잘못된 페이지 주소 업니다.</p>
    </div>
  );
}

export default NotFound;
